import { render, staticRenderFns } from "./LiveVideo.vue?vue&type=template&id=754935ac&scoped=true"
import script from "./LiveVideo.vue?vue&type=script&lang=js"
export * from "./LiveVideo.vue?vue&type=script&lang=js"
import style0 from "./LiveVideo.vue?vue&type=style&index=0&id=754935ac&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754935ac",
  null
  
)

export default component.exports